import { SeuConfigInputItem } from '@seu-types';
import { SeuApiComponent, SeuApiComponentHandle } from '../api';

export const SEU_COMPONENT_INPUT_PLACEHOLDER = 'input-0';
export const SEU_COMPONENT_OUTPUT_PLACEHOLDER = 'output-0';

export const SEU_COMPONENT_REZIRCULATION_INPUT_ID = 'rezirculationToggle';

export type SeuComponentHandleValue = {
  operatingConditionId?: string;
  unit?: string;
  value?: number | null;
  isRemainder?: boolean;
};

export type SeuComponentHandle = {
  id: string;
  isRezirculation?: boolean;
  values?: SeuComponentHandleValue[];
};

export type SeuComponentOutputHandle = SeuComponentHandle & {};

export type SeuComponentBase = {
  name: string;
  componentType: string;
  capex?: number | null;
  inputs: SeuConfigInputItem[];
  inputHandles: SeuComponentHandle[];
  outputHandles: SeuComponentOutputHandle[];
  isDirectionSwapped?: boolean;
  version: number;
};

export type SeuComponent = SeuComponentBase & {
  id: string;
};

export type SeuComponentHandleApi = SeuApiComponentHandle;

export type SeuComponentApi = SeuApiComponent;

export type SeuComponentLibraryCategory = {
  name: string;
  items: SeuComponentLibraryCategoryItem[];
};

export type SeuComponentLibraryCategoryItem = {
  svg: string;
  label: string;
  componentType: string;
  synonyms: string[];
};
